module.exports = __webpack_public_path__ + "img/add_page.ea8395da.svg";